import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import registerSchool from 'controllers/school/registerSchool'
import addSubscription from 'controllers/payment/addSubscription'
import getUserByToken from 'controllers/user/getUserByToken'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'
import { fetchUserByToken } from 'containers/Main/ducks/user'
import MyStoreCheckout from 'template/Modals/MyStoreCheckout';

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
})

const mapDispatchToProps = dispatch => {
  return {
    fetchUserByToken: () => dispatch(fetchUserByToken()),
  };
};
class ModalBody extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      creatingSchool: false
    }

    this.registerSchool = this.registerSchool.bind(this);
    this.tryRegisteringSchool = this.tryRegisteringSchool.bind(this);
    this.afterCreatingSchool = this.afterCreatingSchool.bind(this);
  }

  // Running recursively
  // Look where it's running recursively
  tryRegisteringSchool() {
    const {gSubscription} = this.props;
    const {saas_version} = gSubscription.result;

    if(saas_version === 1){
      addSubscription({plan_codename: "regular_usd_monthly", quantity: 1})
      .then((res) => {
        if(res.result === 'success') {
          this.registerSchool();
        } else if(res.reason === 'credit card rejected, please change other card and try again later') {
          alert.warning(__('Payment rejected, please change other card and try again later', 'changeschool'))
            .then((res)=>{
              MyStoreCheckout({
                onSuccess: (res)=>{
                  this.registerSchool();
                }
              });
            })
        }else if (res.reason === 'user has no payment method.'){
          MyStoreCheckout({
            onSuccess: (res)=>{
              this.registerSchool();
            }
          });
        }
      })
      .catch((err) => { console.log(err) })
    }else {
      this.registerSchool();
    }
  }

  registerSchool() {

    const {
      show,
      proceed,
      dismiss,
      cancel,
      dispatch,
    } = this.props;

    if(typeof(this.formData) == 'undefined'){
      return alert.warning(__('All field must be filled!', 'appwrapper'))
      .then(() => {this.setState({creatingSchool: false})})
    }

    const {title, description, suitAgeLower, city, email, phone} = this.formData
  
    let newFormData = {...this.formData, phone: phone.country_code + phone.national_number}

    if(title == '' || description == '' || suitAgeLower == '' || city == '' || email == '' || phone.length <= 5){
      return alert.warning(__('All field must be filled!', 'appwrapper'))
      .then(() => {this.setState({creatingSchool: false})})
    }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      return alert.warning(__('Invalid email address!', 'appwrapper'))
      .then(() => {this.setState({creatingSchool: false})})
    }
    registerSchool(newFormData)
    .then((res) => {
      this.setState({creatingSchool: false})
      this.props.fetchUserByToken()
      alert.success(__('School Created', 'changeschool'))
      .then(() => {
        this.afterCreatingSchool();
      })
      .catch((error) => {
        console.error(error);
      });
    })
    .catch((error) => {
      this.setState({
        creatingSchool: false,
      });
      alert.warning(__('Please Enter Valid Information', 'changeschool'))
    })
  }

  afterCreatingSchool() {
    const {
      show,
      proceed,
      dismiss,
      cancel,
      dispatch,
    } = this.props;
    proceed({
      schoolCreated: true,
    });
  }

  footerContent(){
    const {gSubscription} = this.props

    if(!gSubscription.result){
      return(<div />)
    }

    if(gSubscription.result.saas_version === 1){
      return(
        <div className='price-on-createschool-modal'>{__('$79 USD / month per school', 'changeschool')}</div>
      )
    }
  }

	render() {
		const {
      show,
      proceed,
      dismiss,
      cancel,
      user,
      gSubscription,
      dispatch,
    } = this.props;

		return (
			<Modal
				className='createschool-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Create School", "changeschool")}
				headerIcon="fa icon-bank"
        fixedWidth={600}
        contentHeight={450}
        onCloseModalClick={dismiss}

        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            isDisabled: ()=>{
              return this.state.creatingSchool === true;
            },
            onClick: ()=>{
              this.tryRegisteringSchool()
              this.setState({
                creatingSchool: true,
              });
            }
          },
        ]}
        footerCustomContent={this.footerContent()}
        isShowingModal={show} >
        <ModalContent
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent.params; }}
        />
			</Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/CreateSchool/ModalBody.js